export const columna = [

	

   {
		"nombre": "Noticias.",
		"imagen": 'noticias/anunciondeclaro.jpg',
	   "funcion": 'Llegó el momento.',
		"url" : 'https://www.facebook.com/share/p/1EUkCS2y2c/',
	},


	{
		"nombre": "Noticias.",
		"imagen": 'noticias/password.jpg',
	   "funcion": '¿Olvidaste tu contraseña?',
		"url" : 'https://www.facebook.com/share/r/18wHQesMZm',
	},

	
	{
		"nombre": "Noticias.",
		"imagen": 'noticias/mayodeclaro.jpg',
	   "funcion": 'Servidoras y servidores públicos',
		"url" : 'https://www.facebook.com/share/r/17kPxDahX4/',
	},

	{
		"nombre": "Noticias.",
		"imagen": 'noticias/buzón.jpg',
		"funcion": "Buzón Digital",
		"url": "https://buzondigitalcontraloria.hidalgo.gob.mx/"
	},

	// // {
	// 	"nombre": "Podcast del Pueblo",
	// 	"imagen": 'noticias/comisarios.jpg',
	// 	"funcion": '"Hidalgo Honesto"',
	// 	"url" : 'https://www.facebook.com/100064535929070/videos/755046710063599/?__so__=permalink&locale=es_LA',
	// },
		



]